import {Component, OnInit} from '@angular/core';
import { properties } from 'src/environments/properties';

@Component({
    selector: 'app-freshpass-title',
    templateUrl: './freshpass-title.component.html',
    styleUrls: ['./freshpass-title.component.scss']
})
export class FreshpassTitleComponent implements OnInit {

    showSmallTitle: boolean;
    properties = properties;

    ngOnInit(): void {
        if (window.screen.width < 990) {
            this.showSmallTitle = true;
        } else {
            this.showSmallTitle = false;
        }
    }

}
